<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="vx-card mb-4">
        <div class="vx-card__body card-body" v-if="loaded">
          <div id="recruitment-checking">
            <h3>{{ $t("BasicInformation") }}:</h3>
            <div>
              <strong>{{ $t("Name") }}:</strong>
              <span>{{ details.personalInfo.firstName }}</span>
            </div>
            <div>
              <strong>{{ $t("Lastname") }}:</strong>
              <span>{{ details.personalInfo.lastName }}</span>
            </div>
            <div>
              <strong>{{ $t("FatherName") }}:</strong>
              <span>{{ details.personalInfo.familyInfo.fatherName }}</span>
            </div>
            <div>
              <strong>{{ $t("DateBirth") }}:</strong>
              <span style="direction: ltr; display: inline-block">{{
                details.personalInfo.birthDate
              }}</span>
            </div>
            <div>
              <strong>{{ $t("BirthCertificateNumber") }}:</strong>
              <span>{{ details.personalInfo.birthCertificateNumber }}</span>
            </div>
            <div>
              <strong> {{ $t("SocialSecurityNumber") }}:</strong>
              <span>{{ details.personalInfo.ssn }}</span>
            </div>
            <div>
              <strong>{{ $t("PlaceBirth") }}‌:</strong>
              <span>{{ details.personalInfo.placeOfBirth }}</span>
            </div>
            <div>
              <strong>{{ $t("PlaceIssue") }}:</strong>
              <span>{{
                details.personalInfo.placeOfIssueBirthCertificate
              }}</span>
            </div>
            <div>
              <strong>{{ $t("Sex") }}:</strong>
              <span v-if="details.personalInfo.gender == 0">{{
                $t("male")
              }}</span>
              <span v-if="details.personalInfo.gender == 1">{{
                $t("female")
              }}</span>
            </div>
            <div v-if="details.personalInfo.gender == 0">
              <strong>{{ $t("ServiceStatus") }}:</strong>
              <span>
                <span
                  v-if="
                    details.personalInfo.militaryServiceInfo
                      .militaryCondition == 0
                  "
                  >{{ $t("EndService") }}</span
                >
                <span
                  v-if="
                    details.personalInfo.militaryServiceInfo
                      .militaryCondition == 1
                  "
                  >{{ $t("BuyService") }}</span
                >
                <span
                  v-if="
                    details.personalInfo.militaryServiceInfo
                      .militaryCondition == 2
                  "
                  >{{ $t("Exemption") }}</span
                >
              </span>
            </div>
            <div v-if="details.personalInfo.gender == 0">
              <strong>?{{ $t("DoExemptionCertificate") }}:</strong>
              <span
                ><span
                  v-if="
                    details.personalInfo.militaryServiceInfo
                      .hasExemptionDocument == true
                  "
                  >{{ $t("Yes") }}</span
                ></span
              >
            </div>
            <div
              v-if="
                details.personalInfo.militaryServiceInfo.hasExemptionDocument ==
                  true
              "
            >
              <strong>{{ $t("TypeExemption") }}‌‌‌‌:</strong>
              <span>{{
                details.personalInfo.militaryServiceInfo.exemptionType
              }}</span>
            </div>
            <div>
              <strong>{{ $t("MaritalStatus") }}‌‌‌‌:</strong>
              <span>
                <span
                  v-if="details.personalInfo.familyInfo.maritalStatus == '0'"
                  >{{ $t("Married") }}</span
                >
                <span
                  v-if="details.personalInfo.familyInfo.maritalStatus == '1'"
                  >{{ $t("Single") }}</span
                >
              </span>
            </div>
            <div v-if="details.personalInfo.familyInfo.maritalStatus == '0'">
              <strong>{{ $t("NameSurnameSpouse") }}:</strong>
              <span>{{ details.personalInfo.familyInfo.spouseName }}</span>
            </div>
            <div v-if="details.personalInfo.familyInfo.maritalStatus == '0'">
              <strong> {{ $t("Spousejob") }}:</strong>
              <span>{{ details.personalInfo.familyInfo.spouseJob }}</span>
            </div>
            <div v-if="details.personalInfo.familyInfo.maritalStatus == '0'">
              <strong>{{ $t("SpousesWorkPhone") }}:</strong>
              <span>{{
                details.personalInfo.familyInfo.spouseWorkplacePhoneNumber
              }}</span>
            </div>
            <div>
              <strong>{{ $t("NumberDependents") }}:</strong>
              <span>{{
                details.personalInfo.familyInfo.numberOfUnderTheTutelagePeople
              }}</span>
            </div>
            <div>
              <strong>{{ $t("NumberChildren") }} :</strong>
              <span>{{
                details.personalInfo.familyInfo.numberOfChildren
              }}</span>
            </div>
            <div>
              <strong>{{ $t("TypeOwnershipResidence") }}‌:</strong>
              <span>
                <span
                  v-if="
                    details.personalInfo.residenceInfo
                      .typeOfOwnershipOfTheResidence == 0
                  "
                  >{{ $t("Rent") }}</span
                >
                <span
                  v-if="
                    details.personalInfo.residenceInfo
                      .typeOfOwnershipOfTheResidence == 1
                  "
                  >{{ $t("OwnerHome") }}</span
                >
              </span>
            </div>
            <div
              v-if="
                details.personalInfo.residenceInfo
                  .typeOfOwnershipOfTheResidence == 0
              "
            >
              <strong>{{ $t("Leased") }}:‌</strong>
              <span>{{ details.personalInfo.residenceInfo.rentAmount }}</span>
            </div>
            <div>
              <strong>{{ $t("HomePhone") }}:</strong>
              <span>{{ details.personalInfo.residenceInfo.phoneNumber }}</span>
            </div>
            <div>
              <strong>{{ $t("HomePhone") }}:</strong>
              <span>{{ details.personalInfo.contactInfo.phoneNumber }}</span>
            </div>
            <div>
              <strong>{{ $t("CallAnotherPhone") }}:</strong>
              <span>{{
                details.personalInfo.contactInfo.secondaryPhoneNumber
              }}</span>
            </div>
            <div>
              <strong>{{ $t("Email") }}:</strong>
              <span>{{ details.personalInfo.contactInfo.email }}</span>
            </div>
            <div>
              <strong>{{ $t("FullAddressResidence") }}‌:</strong>
              <span>{{ details.personalInfo.residenceInfo.address }}</span>
            </div>
            <div>
              <strong
                >{{ $t("employedcompanyinterviewedcompanyemployed") }}؟</strong
              >
              <span
                v-if="
                  details.personalInfo.pastRelationWithCompany.hasRelation ==
                    true
                "
                >{{ $t("Yes") }}</span
              >
              <span
                v-if="
                  details.personalInfo.pastRelationWithCompany.hasRelation ==
                    false
                "
                >{{ $t("No") }}</span
              >
            </div>
            <div
              v-if="
                details.personalInfo.pastRelationWithCompany.hasRelation == true
              "
            >
              <strong>{{ $t("MentionDatesRecords") }}:‌</strong>
              <span>{{
                details.personalInfo.pastRelationWithCompany.description
              }}</span>
            </div>
            <div>
              <strong>{{ $t("BeenConvicted") }}‌‌</strong>
              <span
                v-if="
                  details.personalInfo.criminalConviction
                    .hasCriminalConviction == true
                "
                >{{ $t("Yes") }}</span
              >
              <span
                v-if="
                  details.personalInfo.criminalConviction
                    .hasCriminalConviction == false
                "
                >{{ $t("No") }}</span
              >
            </div>
            <div
              v-if="
                details.personalInfo.criminalConviction.hasCriminalConviction ==
                  true
              "
            >
              <strong>{{ $t("TypeConviction") }}:‌</strong>
              <span>{{
                details.personalInfo.criminalConviction.description
              }}</span>
            </div>
            <h3>{{ $t("Education") }}:</h3>
            <div class="header-row">
              <div class="content">
                <strong>{{ $t("FullNameUniversity") }}‌:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("Degree") }}‌:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("FieldStudy") }}‌:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("StartDate") }}‌:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("EndDate") }}:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("Adjusted") }}‌:</strong>
              </div>
            </div>
            <div
              class="body-row"
              v-for="(info, index) in details.educationInfos"
              :key="index"
            >
              <div class="content">
                <span>{{ info.instituteName }}</span>
              </div>
              <div class="content">
                <span v-if="info.degree == 1">{{ $t("Diploma") }}</span>
                <span v-if="info.degree == 2">{{ $t("Skill") }}</span>
                <span v-if="info.degree == 3">{{ $t("Expert") }}</span>
                <span v-if="info.degree == 4">{{ $t("Bachelor") }}</span>
                <span v-if="info.degree == 5">{{ $t("Phd") }}</span>
              </div>
              <div class="content">
                <span>{{ info.fieldOfStudy }}</span>
              </div>
              <div class="content">
                <span>{{ info.startDate }}</span>
              </div>
              <div class="content">
                <span>{{ info.endDate }}</span>
              </div>
              <div class="content">
                <span>{{ info.rate }}</span>
              </div>
            </div>
            <h3>{{ $t("WorkHistory") }}:</h3>
            <div
              class="wrapper"
              v-for="(workHistory, index) in details.workHistories"
              :key="'index' + index"
            >
              <h4 v-if="index == 0">{{ $t("CurrentWorkplace") }}:</h4>
              <h4
                v-if="
                  index != 0 &&
                    (workHistory.companyName ||
                      workHistory.companyFieldOfActivity)
                "
              >
                {{ $t("PreviousWorkplace") }}
              </h4>
              <div
                class="wrapper"
                v-if="
                  index == 0 ||
                    workHistory.companyName ||
                    workHistory.companyFieldOfActivity
                "
              >
                <div>
                  <strong>{{ $t("CompanyName") }}‌:</strong>
                  <span>{{ workHistory.companyName }}</span>
                </div>
                <div>
                  <strong>{{ $t("FieldActivityCompany") }}:</strong>
                  <span>{{ workHistory.companyFieldOfActivity }}</span>
                </div>
                <div>
                  <strong> {{ $t("PositionOccupation") }}‌:‌</strong>
                  <span>{{ workHistory.post }}</span>
                </div>
                <div>
                  <strong> {{ $t("NumberEmployees") }}:‌</strong>
                  <span>{{ workHistory.employeesCount }}</span>
                </div>
                <div>
                  <strong style="direction: ltr; display: inline-block"
                    >:{{ $t("StartDateCooperation") }}</strong
                  >
                  <span>{{ workHistory.startOfWork }}</span>
                </div>
                <div>
                  <strong style="direction: ltr; display: inline-block"
                    >:{{ $t("EndDateCooperation") }}</strong
                  >
                  <span>{{ workHistory.endOfWork }}</span>
                </div>
                <div>
                  <strong>{{ $t("NameSupervisoManager") }}:‌</strong>
                  <span>{{ workHistory.bossName }}</span>
                </div>
                <div>
                  <strong>{{ $t("ReasonTerminationCooperation") }}:</strong>
                  <span>{{
                    workHistory.reasonOfTerminationOfCooperation
                  }}</span>
                </div>
                <div>
                  <strong>{{ $t("BasicSalaryBenefits") }}:</strong>
                  <span>{{ workHistory.primarySalaryAndBenefits }}</span>
                </div>
                <div>
                  <strong>{{ $t("LatestSalaryBenefits") }}:</strong>
                  <span>{{ workHistory.lastSalaryAndBenefits }}</span>
                </div>
                <div>
                  <strong>{{ $t("Responsibilities") }}‌:</strong>
                  <span>{{ workHistory.responsibilities }}</span>
                </div>
                <div>
                  <strong>{{ $t("PhoneCall") }}:‌</strong>
                  <span>{{ workHistory.phoneNumber }}</span>
                </div>
                <div>
                  <strong>{{ $t("AllowedCall") }} </strong>
                  <span v-if="workHistory.canContact == true">بلی</span>
                  <span v-if="workHistory.canContact == false">خیر</span>
                </div>
              </div>
            </div>
            <h3>{{ $t("HealthItems") }}:</h3>
            <div>
              <strong>{{ $t("BloodType") }} :</strong>
              <span>{{ details.healthCareInfo.bloodType }}</span>
            </div>
            <div>
              <strong> {{ $t("SpecificDisease") }}? </strong>
              <span v-if="details.healthCareInfo.specialDisease"
                >{{ $t("Yes") }}،
                {{ details.healthCareInfo.specialDisease }}</span
              >
              <span v-else>{{ $t("No") }}</span>
            </div>
            <div>
              <strong>{{ $t("SmokingCertainDrugs") }}</strong>
              <span v-if="details.healthCareInfo.tobaccoSpecialMedicine"
                >{{ $t("Yes") }}،
                {{ details.healthCareInfo.tobaccoSpecialMedicine }}</span
              >
              <span v-else>{{ $t("No") }}</span>
            </div>
            <h3>{{ $t("ActivitiesSkills") }}:</h3>
            <h4>{{ $t("EducationalSpecialized") }}</h4>
            <div class="header-row">
              <div class="content">
                <strong>{{ $t("CourseName") }}:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("Year") }}‌:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("Duration") }}‌:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("FullInstitute") }}:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("EventPlace") }}‌:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("CertificateCompletion") }}‌:</strong>
              </div>
            </div>
            <div
              class="body-row"
              v-for="(course, index) in details.specializedCourses"
              :key="'course' + index"
            >
              <div class="content">
                <span>{{ course.courseName }}</span>
              </div>
              <div class="content">
                <span>{{ course.year }}</span>
              </div>
              <div class="content">
                <span>{{ course.period }}</span>
              </div>
              <div class="content">
                <span>{{ course.instituteName }}</span>
              </div>
              <div class="content">
                <span>{{ course.location }}</span>
              </div>
              <div class="content">
                <span v-if="course.hasDegree == true">{{ $t("Yes") }}</span>
                <span v-if="course.hasDegree == false">{{ $t("No") }}</span>
              </div>
            </div>
            <h4>{{ $t("Skills") }}</h4>
            <div>
              <strong>{{ $t("ForeignLanguageOne") }}‌:</strong>
              <span>{{ details.skillInfo.firstLanguage }}</span>
            </div>
            <div>
              <strong>{{ $t("Level") }}‌:</strong>
              <span>{{ details.skillInfo.firstLanguageLevel }}</span>
            </div>
            <div class="wrapper" v-if="details.skillInfo.secondLanguage">
              <div>
                <strong>{{ $t("ForeignLanguageTwo") }}:</strong>
                <span>{{ details.skillInfo.secondLanguage }}</span>
              </div>
              <div>
                <strong>{{ $t("Level") }}:</strong>
                <span>{{ details.skillInfo.secondLanguageLevel }}</span>
              </div>
            </div>
            <div>
              <strong>{{ $t("ComputerSkills") }}‌:</strong>
              <span>{{ details.skillInfo.computerSkills }}</span>
            </div>
            <div>
              <strong>{{ $t("ComputerFamiliar") }}:</strong>
              <span>{{ details.skillInfo.otherComputerSkills }}</span>
            </div>
            <div>
              <strong>{{ $t("HardwareFamiliar") }}:</strong>
              <span>{{ details.skillInfo.hardwareKnowledge }}</span>
            </div>
            <div>
              <strong>{{ $t("OtherSkills") }}:</strong>
              <span>{{ details.skillInfo.otherTechnicalSkills }}</span>
            </div>
            <div>
              <strong>{{ $t("SpecialAchievements") }}:</strong>
              <span>{{ details.skillInfo.specialSuccess }}</span>
            </div>
            <div>
              <strong>{{ $t("DriverLicense") }}</strong>
              <span v-if="details.skillInfo.hasDrivingLicense == 'true'">{{
                $t("Yes")
              }}</span>
              <span v-else>{{ $t("No") }}</span>
            </div>
            <div
              class="wrapper"
              v-if="details.skillInfo.hasDrivingLicense == 'true'"
            >
              <div>
                <strong>{{ $t("Type") }} {{ $t("Basic") }}:</strong>
                <span>{{ details.skillInfo.drivingLicenseBase }}</span>
              </div>
              <div>
                <strong>{{ $t("YearAcquisition") }}:</strong>
                <span>{{ details.skillInfo.drivingLicenseYear }}</span>
              </div>
            </div>
            <div>
              <strong>{{ $t("TraveledAbroad") }}</strong>
              <span v-if="details.travelAbroadInfos[0].country.length > 0">{{
                $t("Yes")
              }}</span>
              <span v-else>{{ $t("No") }}</span>
            </div>
            <div
              class="wrapper"
              v-if="details.travelAbroadInfos[0].country.length > 0"
            >
              <div class="header-row content-3">
                <div class="content">
                  <strong>{{ $t("NameCountry") }}:‌</strong>
                </div>
                <div class="content">
                  <strong>{{ $t("YearTravel") }}:</strong>
                </div>
                <div class="content">
                  <strong>{{ $t("ReasonTravel") }}:</strong>
                </div>
              </div>
              <div
                class="body-row content-3"
                v-for="(travelInfo, index) in details.travelAbroadInfos"
                :key="'travelInfo' + index"
              >
                <div class="content">
                  <span>{{ travelInfo.country }}</span>
                </div>
                <div class="content">
                  <span>{{ travelInfo.year }}</span>
                </div>
                <div class="content">
                  <span>{{ travelInfo.reason }}</span>
                </div>
              </div>
            </div>
            <div class="option-list">
              <strong>{{ $t("LeisureActivities") }}: </strong>
              <span v-if="details.entertainments.reading == true">{{
                $t("Study")
              }}</span>
              <span v-if="details.entertainments.sport == true">
                {{ $t("Sport") }}</span
              >
              <span
                v-if="details.entertainments.membershipInVariousCenters == true"
                >{{ $t("MembershipVarious") }}
              </span>
              <span v-if="details.entertainments.charitableActivities == true">
                {{ $t("ActivitiesCharity") }}</span
              >
              <span v-if="details.entertainments.others">
                {{ details.entertainments.others }}</span
              >
            </div>
            <h3>{{ $t("RestInformation") }}</h3>
            <h4>{{ $t("ReferCommunicate") }}</h4>
            <div class="option-list">
              <strong>{{ $t("AcquaintedAvazang") }}</strong>
              <span v-if="details.referralInfo.isFromAdvertising == true"
                >{{ $t("Poster") }}:{{ details.referralInfo.advertising }}
                <span v-if="details.referralInfo.advertisingDate.length > 0"
                  >-{{ $t("Historian") }}:
                  {{ details.referralInfo.advertisingDate }}</span
                ></span
              >
              <span v-if="details.referralInfo.isFromOtherPerson == true"
                >{{ $t("IntroducingPeople") }} :{{
                  details.referralInfo.referralPerson
                }}</span
              >
              <span v-if="details.referralInfo.isOtherWays == true"
                >{{ $t("Other") }} :{{
                  details.referralInfo.otherWaysDescription
                }}</span
              >
            </div>
            <div>
              <strong>{{ $t("FamiliarEmployees") }}</strong>
              <span
                v-if="details.referralInfo.hasRelationWithOtherEmployee == true"
                >{{ $t("Yes") }}</span
              >
              <span v-else>{{ $t("No") }}</span>
            </div>
            <div
              v-if="details.referralInfo.hasRelationWithOtherEmployee == true"
            >
              <strong>{{ $t("ExplainColleague") }}:</strong>
              <span>{{ details.referralInfo.employeeName }}</span>
            </div>
            <div>
              <strong>{{ $t("PeopleExcept") }}:</strong>
            </div>
            <div class="header-row content-5">
              <div class="content">
                <strong>{{ $t("Name") }}:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("Proportion") }}‌‌:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("PlaceActivity") }}‌:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("PositionActivity") }}:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("ContactPhones") }}:</strong>
              </div>
            </div>
            <div
              class="body-row content-5"
              v-for="(info, index) in details.relationInfos.filter(
                x => x.isFirstDegreeRelative === true
              )"
              :key="'info' + index"
            >
              <div class="content">
                <span>{{ info.name }}</span>
              </div>
              <div class="content">
                <span>{{ info.relation }}</span>
              </div>
              <div class="content">
                <span>{{ info.workCompany }}</span>
              </div>
              <div class="content">
                <span>{{ info.post }}</span>
              </div>
              <div class="content">
                <span>{{ info.phoneNumber }}</span>
              </div>
            </div>
            <h4>{{ $t("FirstRelative") }}:</h4>
            <div>
              <strong>{{ $t("MembersEmergencies") }}:</strong>
            </div>
            <div class="header-row content-3">
              <div class="content">
                <strong>{{ $t("Name") }}:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("Proportion") }}‌‌:</strong>
              </div>
              <div class="content">
                <strong>{{ $t("ContactPhones") }}‌:</strong>
              </div>
            </div>
            <div
              class="body-row content-3"
              v-for="(info, index) in details.relationInfos.filter(
                x => x.isFirstDegreeRelative === false
              )"
              :key="'info-' + index"
            >
              <div class="content">
                <span>{{ info.name }}</span>
              </div>
              <div class="content">
                <span>{{ info.relation }}</span>
              </div>
              <div class="content">
                <span>{{ info.phoneNumber }}</span>
              </div>
            </div>
            <h4>{{ $t("DesiredJob") }}:</h4>
            <div>
              <strong>{{ $t("Jobinterest") }}:</strong>
              <span>{{ details.requestedJobInfo.typesOfCooperation }}</span>
            </div>
            <div>
              <strong style="direction: ltr; display: inline-block"
                >{{ $t("PreparationWork") }}:‌</strong
              >
              <span>{{
                details.requestedJobInfo.readyForCooperationDate
              }}</span>
            </div>
            <div>
              <strong>{{ $t("AmountRequested") }} ({{ $t("Rials") }}):</strong>
              <span>{{ details.requestedJobInfo.requestedSalary }}</span>
            </div>
            <div>
              <strong> {{ $t("OpportunityOvertime") }}‌</strong>
              <span
                v-if="
                  details.requestedJobInfo.canParticipateInOutOfOfficeHours ==
                    true
                "
                >{{ $t("Yes") }}</span
              >
              <span v-else>{{ $t("No") }}</span>
            </div>
            <div>
              <strong>{{ $t("ResumeAttachment") }}:‌</strong>
              <span v-if="details.cvUrl.length > 0">
                <a
                  :href="URLS_CONSTANTS.assets + 'CV/' + details.cvUrl"
                  target="_blank"
                >
                  <vs-button
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="view-btn bg_l_blue"
                    >{{ $t("View") }}</vs-button
                  >
                </a>
              </span>
              <span v-else> {{ $t("Not") }} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
#recruitment-checking .view-btn {
  display: inline-flex;
}

#recruitment-checking .view-btn span {
  color: #fff !important;
  padding: 0 0.2rem;
}

#recruitment-checking .view-btn i:before {
  font-size: 12px;
  top: -2px;
}
</style>
<script>
import { URLS_CONSTANTS } from "../../../../config";
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import "@/assets/scss/vuesax-rtl/pages/_recruitment.scss";
export default {
  name: "Content_management_RecruitmentRequest",
  data() {
    return {
      loaded: false,
      URLS_CONSTANTS: URLS_CONSTANTS
    };
  },
  computed: {
    ...mapGetters({
      details: "HRM/details"
    })
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchInfo: "HRM/fetchSingle"
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchInfo(id).then(() => {
        this.loaded = true;
      });
    }
  }
};
</script>
